import { unorphanLast } from './unorphan';

export const oneLine = (str: string) => str.replace(/\n/g, ' ').trim();

export const oneLineTrim = (str: string) => str.replace(/\s/g, '').trim();

export const oneLineUnorphan = (input: string) => unorphanLast(oneLine(input));
